import { gsap } from 'gsap/all'

export function circularGoal(element: Element): void {
  const svg = element.querySelector('.js-svg') as HTMLElement
  const color = svg.dataset.color
  const segments = [...Array.from(element.querySelectorAll('.js-svg path'))] as HTMLElement[]
  // remove first two from segments array

  gsap.to(segments, {
    delay: Math.random(),
    stagger: 0.5,
    repeatDelay: 0.05,
    duration: 1.5,
    ease: 'expo.inOut',
    fill: color ? color : `#165aff`,
    yoyo: true,
    repeat: -1
  })
}
